import { fetchAPI } from '../utils/api';

export const getCatalog = (payload: Object): Promise<GetCatalogResponse> =>
  fetchAPI(`/channels/catalog`, {
    version: '1.2',
    payload,
  }).then(r => r.json());

export const getCatalogByIds = (query: string): Promise<GetCatalogResponse> =>
  fetchAPI(`/channels/catalog?${query}`, {
    version: '1.2',
  }).then(r => r.json());



// WEBPACK FOOTER //
// ./app/api/catalog.ts